import {Component, OnInit} from '@angular/core';
import {BaseComponent} from "../../../components/base/base.component";
import {AuthenticationService} from "../../../services/authenticate.service";
import {TranslateService} from "@ngx-translate/core";
import {ActivatedRoute, Router} from "@angular/router";
import {RuleCheckerService} from "../../../services/rule-checker.service";

declare const $: any;
declare const App: any;

@Component({
    selector: 'app-layout-partial-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    providers: [RuleCheckerService]
})

export class LayoutPartialSidebarComponent extends BaseComponent implements OnInit {
    logoDfUrlMini = "./assets/styles/default/images/growth.png";
    logoDef = "./assets/styles/default/images/growth.png"
    
    constructor(public override authenticationService: AuthenticationService,
                public override activatedRoute: ActivatedRoute,
                public override translate: TranslateService,
                public router: Router,
                public ruleCheckerService: RuleCheckerService) {
        super(authenticationService, activatedRoute, translate);
    }
    
    override ngOnInit() {
        super.ngOnInit();
        // App.initCore();
        
        $(document).ready(() => {
            $('.nav-item.nav-item-submenu > ul').each((i: any, e: any) => {
                const items = $(e).find('> li');
                if (items.length === 0) {
                    $(e).parent().remove()
                }
            })
        });
    }

    isRouteAudienceActive() {
        return this.router.url.startsWith('/audience');
    }

    isRouteAdminActive() {
        return this.router.url.startsWith('/administrator') || this.router.url.startsWith('/admin');
    }
}
